import { Component, inject } from '@angular/core';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { userActions } from './user/store/user.actions';
import { AuthenticationService } from './shared/services/authentication.service';
import { LanguageService } from './shared/services/language.services';
import { ThemeService } from './shared/services/theme.service';


@Component({
    selector: 'app-root',
    imports: [
    NavbarComponent,
    TranslateModule
],
    providers: [
        LanguageService
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  public languageService = inject(LanguageService);
  private store = inject(Store);
  private themeService = inject(ThemeService);

  public authenticationService = inject(AuthenticationService);
  
  title = 'Studio';

  ngOnInit() {
    this.themeService.initTheme();

    let userToken = this.authenticationService.getUserToken();

    if (userToken) {
      this.store.dispatch(userActions.retryLogin());
    }  
  }

}
